import { useCallback } from 'react';

// types
import type { FilterProps } from './Filter.types';

// components
import { Dropdown } from 'components/Dropdown/Dropdown';

// utils
import { locatorEvent } from '../trackingActions';
import { RADIUS_VALUES } from '../constants';
import { formatDistance } from 'utils/locator';
import { useTracking } from 'utils/hooks/useTracking';

type DistanceFilterProps = {
  maxDistance: FilterProps['maxDistance'];
  setMaxDistance: (distance: FilterProps['maxDistance']) => void;
  isSelectedDropdown: boolean;
  setIsSelectedDropdown: (isSelectedDropdown: boolean) => void;
  distanceLabel: string;
  unit?: string;
};

export function DistanceFilter({
  maxDistance,
  setMaxDistance,
  unit = 'Radius',
  isSelectedDropdown,
  setIsSelectedDropdown,
  distanceLabel,
}: Readonly<DistanceFilterProps>) {
  const track = useTracking();

  const items = RADIUS_VALUES.map((value) => {
    return { id: value, name: formatDistance(value, unit, true) };
  });

  const handleDropdownClick = useCallback(
    (item) => {
      const label = item?.id && formatDistance(item?.id, unit, true);
      setMaxDistance(item?.id || 'none');
      setIsSelectedDropdown(!!item?.id || false);
      track.trackEvent(locatorEvent('Locator-Search', label || distanceLabel));
    },
    [track],
  );

  return (
    <>
      <Dropdown
        placeholder={
          maxDistance === 'none' ? distanceLabel : (formatDistance(maxDistance, unit, true) ?? '')
        }
        label={distanceLabel}
        items={items}
        handleDropdownClick={handleDropdownClick}
        className={`distanceFilter ${isSelectedDropdown ? 'dropdown--selected' : ''}`}
      />
    </>
  );
}
